import AimfoxAvatar from "common/components/ui/AimfoxAvatar";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "common/components/ui/TableV2";

import { formatBillingDate } from "../../../utils";

import type { AgencyClient } from "../../../types";

export default function DesktopTable({ clients }: { clients: AgencyClient[] }) {
  return (
    <Table>
      <thead>
        <tr>
          <TableHead>Client</TableHead>
          <TableHead>Date Added</TableHead>
          <TableHead />
        </tr>
      </thead>

      <tbody>
        {clients.map((client) => {
          const {
            id,
            first_name: firstName,
            last_name: lastName,
            email,
            created_at: createdAt,
          } = client;

          return (
            <TableRow key={id}>
              <TableCell className="flex items-center gap-2.5">
                <AimfoxAvatar firstName={firstName} lastName={lastName} />

                <div className="flex flex-col items-start gap-1">
                  <span className="text-md-bold text-black-950">
                    {firstName} {lastName}
                  </span>

                  <span className="inline-block max-w-[40ch] overflow-hidden text-ellipsis text-xs-medium text-black-500">
                    {email}
                  </span>
                </div>
              </TableCell>

              <TableCell className="text-button-xs text-black-950">
                {formatBillingDate(createdAt * 1000)}
              </TableCell>

              <TableCell></TableCell>
            </TableRow>
          );
        })}
      </tbody>
    </Table>
  );
}
